import styled, { keyframes } from "styled-components";
import { ReactComponent as NewLogo } from "../../assets/images/common/new_logo.svg";

const scaleIn = keyframes`
  from {
    transform: scale(.3, .3);
    opacity: .5;
  }

  to {
    transform: scale(1.4, 1.4);
    opacity: 0;
  }
`;

export const DarkBackground = styled.div`
  background-color: #00000073;
  inset: 0;
  z-index: 0;
  position: fixed;
  height: 100%;
  width: 100%;
`;

export const PopupMainContainer = styled.div`
  font-family: "Averta CY";
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background-color: transparent;
  width: ${(props) => (props.hasImage ? "auto" : "489px")};
  max-width: calc(100% - 20px);
  transition: all 0.3s ease-in-out;
`;

export const PopupContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.backgroundColor};
  transition: all 0.3s ease-in-out;
`;

export const LeftSide = styled.div`
  flex: 1 1 59.926470589%;
  padding-left: ${(props) => (props.hasImage ? "84px" : "0")};
  padding-bottom: 25px;
  padding-top: 138px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  align-items: ${(props) => (props.hasImage ? "initial" : "center")};
  min-width: ${(props) => (props.hasImage ? "400px" : "321px")};

  @media (max-width: 768px) {
    padding-top: 80px;
    padding-left: 32px;
    min-width: 280px;
  }

  @media (max-width: 576px) {
    padding-top: 40px;
    padding-left: 16px;
    min-width: 250px;
  }
`;

export const RightSide = styled.div`
  flex: 1 1 40.073529411%;
  display: flex;
  position: relative;
  border-radius: 0px 8px 8px 0px;
  min-width: 20rem;

  @media (max-width: 768px) {
    margin-left: 16px;
    display: block;
  }

  @media (max-width: 576px) {
    margin-left: 4px;
  }
`;

export const PopupImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;

  @media (max-width: 768px) {
    height: 100%;
    max-width: 100%;
    object-fit: cover;
  }
`;

export const Overlay = styled.div`
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.2;
  border-radius: 0px 8px 8px 0px;
  background: ${(props) => props.buttonColor};
`;

export const Subtitle = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.color};
  margin-bottom: 8px;
`;

export const Header = styled.p`
  font-weight: 600;
  font-size: 28px;
  line-height: 35px;
  color: ${(props) => props.color};
  margin-bottom: 4px;

  @media (max-width: 576px) {
    font-size: 22px;
    line-height: 24px;
  }
`;

export const Description = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${(props) => props.color};
  margin-bottom: 26px;
  max-width: 235px;

  @media (max-width: 576px) {
    margin-top: 0;
    max-width: 180px;
  }
`;

export const SubmitButton = styled.button`
  background-color: ${(props) => props.backgroundColor};
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${(props) => props.color};
  width: 321px;
  height: 46px;
  border: none;
  border-radius: 8px;
  margin: 12px 30px 13px 0;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};

  @media (max-width: 768px) {
    width: 250px;
  }

  @media (max-width: 576px) {
    max-width: 200px;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const ConfirmIconContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin: 80px 0;
  overflow: hidden;
  width: 351px;
`;

export const ConfirmIconItem = styled.div`
  z-index: 100;
  padding: 5px;
`;

export const Circle = styled.div`
  border-radius: 50%;
  width: 180px;
  height: 180px;
  background-color: lightgreen;
  position: absolute;
  opacity: 0;
  animation: ${scaleIn} 2s infinite cubic-bezier(0.36, 0.11, 0.89, 0.32);
  animation-delay: ${(props) => props.delay};
`;

export const LogoContainer = styled.div`
  padding-top: 87px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding-top: 40px;
  }

  @media (max-width: 576px) {
    padding-top: 20px;
  }
`;

export const LogoText = styled.p`
  font-size: 10px;
  color: #77808d;
  padding-right: 5px;
`;

export const StyledNewLogo = styled(NewLogo)`
  width: 65px;
`;
